import { graphql, Link, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";

const Hero = ({ title, description, bgImage, altBgImage }) => {
  const data = useStaticQuery(query);

  return (
    <>
      {bgImage && (
        <div className="container p-0 ">
          <div className="flex flex-col">
            {!description && title && (<h1 className="text-blue">{title}</h1>)}
          </div>
          <div className="rounded-4xl overflow-hidden mb-12">
            <div className="h-28rem relative">
              <div>
                <GatsbyImage alt={altBgImage || ''} image={getImage(bgImage)} className="object-cover"></GatsbyImage>
              </div>
              <div className="absolute top-0 w-full h-full flex flex-col justify-around items-center p-8">
                {title && (<h1 className="text-black text-center font-bold text-5xl">{title}</h1>)}
                {description && (<p className="text-black font-semibold text-xl text-center">{description}</p>)}
              </div>
            </div>
          </div>
        </div>
      )}
      {
        !bgImage && (
          <div className="container p-0 rounded-4xl overflow-hidden mb-12">
            <div className="h-29rem relative">
              <GatsbyImage className='object-cover w-full h-full absolute left-0 top-0 opacity-50 lg:opacity-100' alt='hero' image={getImage(data.backgrounds.nodes[0].childImageSharp)} ></GatsbyImage>
              <div className="absolute mt-10 w-full md:w-7/12 lg:w-5/12 px-4 md:pl-16 top-0">
                <h1 className="text-4xl text-blue font-light normal-case leading-snug sm:mb-4">
                  Bolsa personalizada o saco en algodón personalizado? Es nuestra especialidad
                </h1>
                <Link
                  className="btn btn-blue btn-rounded uppercase py-3 rounded-3xl inline-block text-center h-auto"
                  to="/categoria-producto/bolsas-personalizadas"
                >
                  Descubrir nuestros tote bags personalizados
                </Link>
               
              </div>
            
            </div>
          </div>
        )
      }
    </>)
};

const query = graphql`
      query {
        backgrounds: allFile(
          filter: {sourceInstanceName: {eq: "backgrounds"}, name: {eq: "new_bandeau"}}
        ) {
          nodes {
            relativePath
            childImageSharp  {
              gatsbyImageData(quality: 90, width: 1200)
            }
          }
        }
      }
    `

export default Hero;
